import React from 'react';
import AskSLAMAI from '../../components/chat/AskSLAMAI';

const GOLF_PROMPTS = [
  { id: 1, text: 'Analyze my swing mechanics from this video', icon: '⛳' },
  { id: 2, text: 'Compare driver launch angle and spin rate', icon: '📊' },
  { id: 3, text: 'Course strategy for a par-5 with water hazard', icon: '🗺️' },
  { id: 4, text: 'Short game improvement drills for chipping', icon: '🎯' },
  { id: 5, text: 'Putting stroke analysis and green reading tips', icon: '🏌️' },
  { id: 6, text: 'Mental game preparation for tournament play', icon: '🧠' },
];

export default function GolfAskAI() {
  return (
    <AskSLAMAI
      sport="golf"
      prompts={GOLF_PROMPTS}
      endpoint="/api/chat/statcast"
      accentColor="green"
    />
  );
}
